import React from 'react';
import {Table as BaseTable} from 'desktop/sports/cfb/players-list/showdown';

class Table extends BaseTable {}

export {Table};
